<template>
  <div class="wrapper">
    <el-carousel height="5.625rem">
      <el-carousel-item v-for="item in carouseList" :key="item.id">
        <img
          :src="item.path"
          class="carouselImg"
          alt="婚礼堂悦动,婚礼堂,banner"
          @click="toLink(item.link)"
        />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { getCarouselList } from '@/api/index';
import store from '@/store/index';

export default {
  components: {
  },
  data() {
    return {
      carouseList: [
        {
          id: '4',
          path: require('@/assets/banner/banner3.jpg'),
          // link: 'https://mp.weixin.qq.com/s/OW4MafDjOO8awQRHR0HEQg',
        },
        // {
        //   id: '5',
        //   path: require('@/assets/banner/banner2.jpg'),
        //   // link: 'https://mp.weixin.qq.com/s/OW4MafDjOO8awQRHR0HEQg',
        // },
      ],
      lrBoxVisible: false,
    };
  },
  created() {
    // getCarouselList()
    //   .then((res) => {
    //     console.log('轮播图:', res);
    //     // this.carouseList = res.list;
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  },
  methods: {
    toLink(link) {
      if (link === 'yx') {
        if (store.state.token) {
          window.location.href = `${window.location.origin}/hm-customer/index.html#/app/yx`;
        } else {
          this.openLrBox(0);
        }
      } else if (link) {
        window.open(link, '_blank');
      }
    },
    openLrBox(type) {
      this.lrBoxVisible = true;
      this.$nextTick(() => {
        this.$refs.lrBoxDom.openBoxByType(type);
      });
    },
    handleCloseLrBox() {
      this.lrBoxVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 1920px;
  // height: 1080px;
  .carouselImg {
    cursor: pointer;
    width: 100%;
    height: 100%;
  }
}
</style>
